export const GET_OPPORTUNITY = 'GET_OPPORTUNITY';
export const SET_OPPORTUNITY = 'SET_OPPORTUNITY';